module.exports = __webpack_public_path__ + "img/凌烟阁-二维码.f0586bc0.png";